import React from 'react'

import Collapsible from "react-collapsible";

import General from '../utils/General'

import LayoutEditor from "./LayoutEditor";
import Border from "./Border";
import Dropdown from "./Dropdown";
import ColorPicker from "./ColorPicker";
import { IconAndSVGPicker } from "./IconPickerGrid";

import Toggle from "./sectioninputs/Toggle";

import PortalModal from "./modal/PortalModal";
import DefaultData from "../utils/DefaultData";
import { updateIconType, updateIconValue } from './constants/utils';
import { productSettingsIds } from './constants/general';
import { RangeSlider } from './modal/PopupManagerModal';
import { getCleanedPixelValue, storefrontPopupDeviceTypesCollection } from './constants/storefrontPopupConstants';
import { renderColorPickers } from '../utils/renderColorPickers';

const DEFAULT_VISIBILITY = {
  desktop: true,
  mobile: true,
  mobilelarge: true,
  tablet: true,
  tabletlarge: true,
};
const OPTIONS_BORDER_RADIUS = [
  { label: 'Square', value: '0px' },
  { label: 'Rounded', value: '6px' }
];
const COLLAPSIBLE_BORDER_RADIUS = [
  {label: 'none', value: "none"},
  { label: 'Square', value: '0px' },
  { label: 'Rounded', value: '6px' }
];
const PRODUCT_BORDER_RADIUS = [
  { label: 'Square', value: '0px' },
  { label: 'Rounded', value: '6px' },
  { label: 'Fully Rounded', value: '30px' }
];

const PRODUCT_ALIGNMENT = [
  { label: 'Left', value: 'left' },
  { label: 'Right', value: 'right' },
  { label: 'Center', value: 'center' },
];
const PRODUCT_WIDTH = [
  { label: 'Full Width', value: '100%' },
  { label: 'Content', value: 'max-content' },
];
const OPTIONS_Layout = [
  { label: 'Vertical Tiles', value: 'radio' },
  { label: 'Horizontal Tiles', value: 'horizontal' },
  { label: 'Tab', value: 'tab' },
  { label: 'Checkbox', value: 'checkbox'}
];
const OPTIONS_DISCOUNT= [
  { label: 'Amount', value: 'price' },
  { label: 'Percentage', value: 'percent' },
  { label: 'Amount & Percentage', value: 'both' },
]

const OPTIONS_PRODUCT_DESCRIPTION_SHAPE = [
  { label: 'Square', value: 'square' },
  { label: 'Rounded', value: 'rounded' }
]
export const visibilityStyles = {
  container: {
    cursor: 'pointer',
    position: 'relative',
    transition: 'all 0.2s ease'
  },
  iconWrapper: (isVisible) => ({
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    opacity: isVisible ? 1 : 0.3,
    transition: 'all 0.2s ease'
  }),
  icon: (isVisible) => ({
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: isVisible ? '#2196F3' : '#757575',
    transition: 'color 0.2s ease'
  }),
  checkmark: {
    position: 'absolute',
    bottom: '-2px',
    right: '-2px',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: '#4CAF50',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid white',
    animation: 'popIn 0.2s ease'
  }
};
export default class ProductDetailSettings extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
      quickEditScroll: true
    }
    this.settingsRef = React.createRef();
  }

  _scrollSettinsInView() {
    if (this.settingsRef?.current && this.props.show && this.props.openProductSettingsSection) {
      this.settingsRef.current.scrollIntoView({
        behavior: 'smooth'
      })
      this.setState({
        quickEditScroll: false
      })
    }
  }

  _renderRefElement(openSection) {
    return this.state.quickEditScroll ? <div ref={openSection ? this.settingsRef : ""}></div> : null;
  }

  componentDidMount() {
    this._scrollSettinsInView()
  }

  componentDidUpdate() {
    this._scrollSettinsInView()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  handleLayoutUpdate = (layoutOrder) => {
    const {data} = this.state;
    if (!data) {
      return;
    }

    data.layoutOrder = layoutOrder;
    this.setState({layoutOrder}, () => {
      this.props.onUpdated(data);
      setTimeout(() => General.updateAll(), 300);
    });
  };

  _renderLayoutPreviewUI() {
    let { data } = this.state
    return (
      <LayoutEditor
        title={"Page Layout"}
        layout={data.layoutOrder || [...DefaultData.PRODUCT_PAGE_LAYOUT]}
        onChange={this.handleLayoutUpdate}
        defaultLayout={[...DefaultData.PRODUCT_PAGE_LAYOUT]}
        onReset={() => {
          this.setState({showResetLayoutModal: true});
        }}
        data={data}
        onUpdated={(data) => {
          this.setState({
            data
          }, () => this.props.onUpdated(data))
        }}
      />
    );
  }

  handleAutoPlayCarouselToggle = (checked) => {
    let { data } = this.state;
    data.autoplay_carousel_toggle = checked;
    const slider = window.flickityStore.mainSlider;
    if (!slider) return;

    checked ? slider.playPlayer() : slider.stopPlayer();
    this.props.onUpdated(data);
  };

  handleStickyLeftColumnToggle = (checked) => {
    const { data } = this.state;
    data.sticky_left_column = checked;
    this.setState({ data }, () => {
      this.props.onUpdated(data);
    });
  };

  handleSliderPositionChange = (option) => {
    const { data } = this.state;
    data.slider_position = option.value;
    this.setState({ data }, () => {
      this.props.onUpdated(data);
      setTimeout(() => {
        General.updateAll();
        window.dispatchEvent(new Event('resize'));
      }, 0);
    });
  };

  _displaySettings() {
    let { data } = this.state
    let WIDTHOPTIONS = [
      {
        value: "standard",
        label: "Standard"
      },
      {
        value: "even",
        label: "Even"
      }
    ]
    return (
      <>
        <Border>
          <Collapsible
            trigger={"Display"}
          >
            <br/>
            <span>Column Width</span>
            <Dropdown
              options={WIDTHOPTIONS}
              value={WIDTHOPTIONS.find(
                (mode) => mode.value === (data.column_width || "standard")
              )}
              onChange={option => {
                data.column_width = option.value
                this.props.onUpdated(data)
              }}
              placeholder="Select An Option"
            />
            <br/>
            <Toggle
              id="stickyLeftColumnToggle"
              title="Sticky Left Column"
              checked={data?.sticky_left_column}
              onChange={this.handleStickyLeftColumnToggle}
            />
          </Collapsible>
        </Border>
      </>
    )
  }
  _renderProductImageSettings() {
    const { data } = this.state;

    // Local option sets (kept here to avoid touching globals)
    const SLIDEROPTIONS = [
      { value: "below", label: "Below" },
      { value: "left", label: "Left" }
    ];
    const IMAGE_SHAPE_OPTIONS = [
      { value: "rounded", label: "Rounded" },
      { value: "square",  label: "Square" }
    ];
    const CAROUSEL_SHAPE_OPTIONS = [
      { value: "rounded", label: "Rounded" },
      { value: "square",  label: "Square" }
    ];
    const NAV_SHAPE_OPTIONS = [
      { value: "rounded", label: "Rounded" },
      { value: "square",  label: "Square" }
    ];

    const openSection =
      this.props.openProductSettingsSection === productSettingsIds.productImage;

    return (
      <>
        {this._renderRefElement(openSection)}
        <Border>
          <Collapsible trigger={"Product Image & Carousel"} open={openSection}>
            <br/>
            <Toggle
              id="autoplayToggle"
              title="Autoplay Carousel"
              checked={!!data.autoplay_carousel_toggle}
              onChange={this.handleAutoPlayCarouselToggle}
            />
            <span className="d-block mb-1">Product Image Shape</span>
            <Dropdown
              options={IMAGE_SHAPE_OPTIONS}
              value={IMAGE_SHAPE_OPTIONS.find(
                o => o.value === (data.image_shape || "rounded")
              )}
              onChange={(opt) => {
                data.image_shape = opt.value;
                this.props.onUpdated(data);
                setTimeout(() => General.updateAll(), 300);
              }}
              placeholder="Select Shape"
            />
            <span className="d-block mb-1">Carousel Images Shape</span>
            <Dropdown
              options={CAROUSEL_SHAPE_OPTIONS}
              value={CAROUSEL_SHAPE_OPTIONS.find(
                o => o.value === (data.carousel_shape || "rounded")
              )}
              onChange={(opt) => {
                data.carousel_shape = opt.value;
                this.props.onUpdated(data);
                setTimeout(() => {
                  General.updateAll();
                  window.dispatchEvent(new Event('resize'));
                }, 0);
              }}
              placeholder="Select Shape"
            />
            <span className="d-block mb-1">Icon Buttons Shape</span>
            <Dropdown
              options={NAV_SHAPE_OPTIONS}
              value={NAV_SHAPE_OPTIONS.find(
                o => o.value === (data.image_nav_shape || "square")
              )}
              onChange={(opt) => {
                data.image_nav_shape = opt.value;
                this.setState({ data }, () => {
                  this.props.onUpdated(data);
                  setTimeout(() => {
                    General.updateAll();
                    window.dispatchEvent(new Event('resize'));
                  }, 0);
                });
              }}
              placeholder="Select Shape"
            />
            <span className="d-block mb-1">Image Slider Position</span>
            <Dropdown
              options={SLIDEROPTIONS}
              value={SLIDEROPTIONS.find(
                o => o.value === (data.slider_position || "below")
              )}
              onChange={this.handleSliderPositionChange}
              placeholder="Select Position"
            />
            <ColorPicker
              title="Product Image Border Color"
              color={data.image_border_color || ""}
              onColorSelected={(color) => {
                data.image_border_color = color;
                this.props.onUpdated(data);
              }}
            />
            <ColorPicker
              title="Button Color"
              onColorSelected={(color) => {
                data.image_nav_button_color = color;
                this.setState({ data }, () => {
                  this.props.onUpdated(data);
                  setTimeout(() => {
                    General.updateAll();
                    window.dispatchEvent(new Event('resize'));
                  }, 0);
                });
              }}
            />
            <ColorPicker
              title="Selected Image Border Color"
              color={data.image_selected_border_color || ""}
              onColorSelected={(color) => {
                data.image_selected_border_color = color;
                this.props.onUpdated(data);
              }}
            />
          </Collapsible>
        </Border>
      </>
    );
  }
  _ensureDetailVisibility(detailCount = 9) {
    const { data } = this.state;
    const nextData = { ...data };

    nextData.visibility = nextData.visibility || {};
    nextData.visibility.detail = Array.isArray(nextData.visibility.detail)
      ? [...nextData.visibility.detail]
      : [];

    for (let i = 0; i < detailCount; i++) {
      nextData.visibility.detail[i] = {
        ...DEFAULT_VISIBILITY,
        ...(nextData.visibility.detail[i] || {}),
      };
    }

    return nextData;
  }
  _handleDetailSelect = (opt) => {
    const idx =
      typeof opt?.value === 'string' && opt.value.startsWith('detail-')
        ? Math.max(0, parseInt(opt.value.replace('detail-', ''), 10) - 1)
        : 0;

    const nextData = this._ensureDetailVisibility();
    this.setState({ data: nextData, selectedDetailIndex: idx });
  };
  _updateDetailVisibility = (device, checked) => {
    const { selectedDetailIndex = null } = this.state;
    const defaultIndex = this.props.defaultIndex ? this.props.defaultIndex - 1 : 0;
    const selected = selectedDetailIndex || selectedDetailIndex === 0 ? selectedDetailIndex : defaultIndex;
    const nextData = this._ensureDetailVisibility();

    nextData.visibility.detail[selected] = {
      ...nextData.visibility.detail[selected],
      [device]: !!checked,
    };

    this.setState({ data: nextData }, () => {
      this.props.onUpdated(nextData);

      setTimeout(() => {
        General.updateAll();
        try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      }, 0);
    });
  };
  _renderToggles() {
    const { data, selectedDetailIndex = null } = this.state;
    const defaultIndex = this.props.defaultIndex ? this.props.defaultIndex - 1 : 0;
    const selected = selectedDetailIndex || selectedDetailIndex === 0 ? selectedDetailIndex : defaultIndex;
    const details = data?.visibility?.detail || [];
    const visibility = {
      ...DEFAULT_VISIBILITY,
      ...(details[selected] || {}),
    };
    return (
      <div className='d-flex justify-content-around'>
        {storefrontPopupDeviceTypesCollection.map((item, idx) => {
          const isVisible = visibility[item.device];
          return (
            <div
              key={idx}
              className="storefront-popup-settings-toggle"
              style={visibilityStyles.container}
              onClick={() => this._updateDetailVisibility(item.device, !isVisible)}
              title={`${item.deviceName}: ${isVisible ? 'Visible' : 'Hidden'}`}
            >
              <div style={visibilityStyles.iconWrapper(isVisible)}>
                <div 
                  style={visibilityStyles.icon(isVisible)}
                  dangerouslySetInnerHTML={{ __html: item.svg }}
                />
                {isVisible && (
                  <div style={visibilityStyles.checkmark}>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="white">
                      <path d="M2 5 L4 7 L8 3" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    );
  }
  _renderDetailSettings() {
    const { selectedDetailIndex = null } = this.state;
    const openSection =
      this.props.openProductSettingsSection === productSettingsIds.detail;

    const defaultIndex = this.props.defaultIndex ? this.props.defaultIndex - 1 : 0;
    const selected = selectedDetailIndex || selectedDetailIndex === 0 ? selectedDetailIndex : defaultIndex;

    const DETAIL_OPTIONS = Array.from({ length: 9 }).map((_, i) => ({
      value: `detail-${i + 1}`,
      label: `Detail ${i + 1}`,
    }));

    const currentOption = DETAIL_OPTIONS[selected];

    return (
      <>
        {this._renderRefElement(openSection)}
        <Border>
          <Collapsible trigger="Detail" open={openSection}>
            <br />
            <Dropdown
              options={DETAIL_OPTIONS}
              value={currentOption}
              placeholder="Select An Option"
              onChange={this._handleDetailSelect}
            />
            <h4 className="d-block mb-2">Visibility</h4>
            {this._renderToggles()}
          </Collapsible>
        </Border>
      </>
    );
  }
  _productPriceSettings() {
    let {data} = this.state;
    const openSection = this.props.openProductSettingsSection === productSettingsIds.productPrice;
    return (
      <>
        <Border>
          <Collapsible
            trigger="Product Price"
            open={openSection}
          >
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Border Style</span>
              <Dropdown
                options={PRODUCT_BORDER_RADIUS}
                value={PRODUCT_BORDER_RADIUS.find(
                  (opt) => opt.value === data["product_price_border_style"]
                )}
                onChange={option => {
                  data["product_price_border_style"] = option.value
                  this.props.onUpdated(data)
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <ColorPicker
              title="Border color"
              color={data.product_price_border_color}
              onColorSelected={(color) => {
                data["product_price_border_color"] = color
                this.props.onUpdated(data)
              }}
            />
            <br/>
            <ColorPicker
              title="Price color"
              color={data.product_price_color}
              onColorSelected={(color) => {
                data["product_price_color"] = color
                this.props.onUpdated(data)
              }}
            />
            <br/>
            <ColorPicker
              title="Label color"
              color={data.product_price_label_color}
              onColorSelected={(color) => {
                data["product_price_label_color"] = color
                this.props.onUpdated(data)
              }}
            />
            <br/>
            <ColorPicker
              title="Compare at Price color"
              color={data.product_compare_at_price_color}
              onColorSelected={(color) => {
                data["product_compare_at_price_color"] = color
                this.props.onUpdated(data)
              }}
            />
            <br/>
            <ColorPicker
              title="Background color"
              color={data.product_price_background_color}
              onColorSelected={(color) => {
                data["product_price_background_color"] = color
                this.props.onUpdated(data)
              }}
            />
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Text Alignment</span>
              <Dropdown
                options={PRODUCT_ALIGNMENT}
                value={PRODUCT_ALIGNMENT.find(
                  (opt) => opt.value === data["product_price_alignment"]
                )}
                onChange={option => {
                  data["product_price_alignment"] = option.value
                  this.props.onUpdated(data)
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Width</span>
              <Dropdown
                options={PRODUCT_WIDTH}
                value={PRODUCT_WIDTH.find(
                  (opt) => opt.value === data["product_price_width"]
                )}
                onChange={option => {
                  data["product_price_width"] = option.value
                  this.props.onUpdated(data)
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <RangeSlider
              label={"Padding"}
              min={0}
              max={50}
              step={1}
              value={getCleanedPixelValue(data["product_price_padding"]) || 0}
              onChange={(propertyName, value) => {
                data["product_price_padding"] = `${value}px`
                this.props.onUpdated(data)
              }}
              propertyName="padding"
              labelClassName="storefront-popup-settings-sub-heading"
            />
          </Collapsible>
        </Border>
      </>
    )
  }
  _productTitleSettings() {
    let {data} = this.state;
    const openSection = this.props.openProductSettingsSection === productSettingsIds.productTitle;
    return (
      <>
        <Border>
          <Collapsible
            trigger="Product Title"
            open={openSection}
          >
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Border Style</span>
              <Dropdown
                options={PRODUCT_BORDER_RADIUS}
                value={PRODUCT_BORDER_RADIUS.find(
                  (opt) => opt.value === data["product_title_border_style"]
                )}
                onChange={option => {
                  data["product_title_border_style"] = option.value
                  this.props.onUpdated(data)
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <ColorPicker
              title="Border color"
              color={data.product_title_border_color}
              onColorSelected={(color) => {
                data["product_title_border_color"] = color
                this.props.onUpdated(data)
              }}
            />
            <br/>
            <ColorPicker
              title="Title color"
              color={data.product_title_color}
              onColorSelected={(color) => {
                data["product_title_color"] = color
                this.props.onUpdated(data)
              }}
            />
            <br/>
            <ColorPicker
              title="Background color"
              color={data.product_title_background_color}
              onColorSelected={(color) => {
                data["product_title_background_color"] = color
                this.props.onUpdated(data)
              }}
            />
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Text Alignment</span>
              <Dropdown
                options={PRODUCT_ALIGNMENT}
                value={PRODUCT_ALIGNMENT.find(
                  (opt) => opt.value === data["product_title_alignment"]
                )}
                onChange={option => {
                  data["product_title_alignment"] = option.value
                  this.props.onUpdated(data)
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Width</span>
              <Dropdown
                options={PRODUCT_WIDTH}
                value={PRODUCT_WIDTH.find(
                  (opt) => opt.value === data["product_title_width"]
                )}
                onChange={option => {
                  data["product_title_width"] = option.value
                  this.props.onUpdated(data)
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <RangeSlider
              label={"Padding"}
              min={0}
              max={50}
              step={1}
              value={getCleanedPixelValue(data["product_title_padding"]) || 0}
              onChange={(propertyName, value) => {
                data["product_title_padding"] = `${value}px`
                this.props.onUpdated(data)
              }}
              propertyName="padding"
              labelClassName="storefront-popup-settings-sub-heading"
            />
          </Collapsible>
        </Border>
      </>
    )
  }
  _renderVariantSettings() {
    let {
      data
    } = this.state

    let imgTileVariantType = ""

    const variantTypeIndexes = [1, 2, 3]

    variantTypeIndexes.forEach((item) => {
      const key = `variant${item}_style`
      if (data[key] === "img_tile") {
        imgTileVariantType = key
      }
    })
    const openSection = this.props.openProductSettingsSection === productSettingsIds.variants
    return (
      <>
        {this._renderRefElement(openSection)}
        <Border>
          <Collapsible
            trigger={"Variants"}
            open={openSection}
          >
            {this._renderVariantTilePriceDisplaySettings()}

            {this._renderColorType()}

            {this._renderVariantType(1, imgTileVariantType)}

            {this._renderVariantType(2, imgTileVariantType)}

            {this._renderVariantType(3, imgTileVariantType)}
            <b><span>Parent</span></b>
            <div className="mb-3">
              <span className="d-block mb-2">Border Style</span>
              <Dropdown
                options={OPTIONS_BORDER_RADIUS}
                value={OPTIONS_BORDER_RADIUS.find(
                  (opt) => opt.value === data["variant_border_style"]
                )}
                onChange={(option) => {
                  data["variant_border_style"] = option.value;
                  this.props.onUpdated(data);
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <ColorPicker
              title="Border color"
              color={data.variant_border_color}
              onColorSelected={(color) => {
                data["variant_border_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <ColorPicker
              title="Background color"
              color={data.variant_bg_color}
              onColorSelected={(color) => {
                data["variant_bg_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <RangeSlider
              label={"Padding"}
              min={0}
              max={35}
              step={1}
              value={getCleanedPixelValue(data["variant_padding"]) || 0}
              onChange={(propertyName, value) => {
                data["variant_padding"] = `${value}px`;
                this.props.onUpdated(data);
              }}
              propertyName="padding"
              labelClassName="storefront-popup-settings-sub-heading"
            />
            <b><span>Variant Elements</span></b>
            <ColorPicker
              title="Label Text color"
              color={data.variant_label_text_color}
              onColorSelected={(color) => {
                data["variant_label_text_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <b><span>Button/Tile</span></b>
            <ColorPicker
              title="Button/Tile color"
              color={data.variant_tile_color}
              onColorSelected={(color) => {
                data["variant_tile_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <ColorPicker
              title="Text color"
              color={data.variant_tile_text_color}
              onColorSelected={(color) => {
                data["variant_tile_text_color"] = color;
                this.props.onUpdated(data);
              }}
            />
             <ColorPicker
              title="Border color"
              color={data.variant_tile_border_color}
              onColorSelected={(color) => {
                data["variant_tile_border_color"] = color;
                this.props.onUpdated(data);
              }}
            />
             <ColorPicker
              title="Selected color"
              color={data.selected_tile_color}
              onColorSelected={(color) => {
                data["selected_tile_color"] = color;
                this.props.onUpdated(data);
              }}
            />
             <ColorPicker
              title="Selected Border color"
              color={data.selected_tile_border_color}
              onColorSelected={(color) => {
                data["selected_tile_border_color"] = color;
                this.props.onUpdated(data);
              }}
            />
             <ColorPicker
              title="Price color"
              color={data.variant_price_color}
              onColorSelected={(color) => {
                data["variant_price_color"] = color;
                this.props.onUpdated(data);
              }}
            />
             <ColorPicker
              title="Compare at price color"
              color={data.variant_compare_at_price_color}
              onColorSelected={(color) => {
                data["variant_compare_at_price_color"] = color;
                this.props.onUpdated(data);
              }}
            />
          </Collapsible>
        </Border>
      </>
    )
  }

  _customMessageSettings() {
    let { data } = this.state;
    const openSection = this.props.openProductSettingsSection === productSettingsIds.customMessageOptions;

    return (
      <>
        <Border>
          <Collapsible trigger="Custom Message Options" open={openSection}>
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Border Style</span>
              <Dropdown
                options={OPTIONS_BORDER_RADIUS}
                value={OPTIONS_BORDER_RADIUS.find(
                  (opt) => opt.value === data["custom_message_border_style"]
                )}
                onChange={(option) => {
                  data["custom_message_border_style"] = option.value;
                  this.props.onUpdated(data);
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <ColorPicker
              title="Border color"
              color={data.custom_message_border_color}
              onColorSelected={(color) => {
                data["custom_message_border_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <ColorPicker
              title="Text color"
              color={data.custom_message_color}
              onColorSelected={(color) => {
                data["custom_message_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <ColorPicker
              title="Background color"
              color={data.custom_message_background_color}
              onColorSelected={(color) => {
                data["custom_message_background_color"] = color; // FIXED
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Text Alignment</span>
              <Dropdown
                options={PRODUCT_ALIGNMENT}
                value={PRODUCT_ALIGNMENT.find(
                  (opt) => opt.value === (data["custom_message_alignment"] ?? 'left')
                )}
                onChange={(option) => {
                  data["custom_message_alignment"] = option.value;
                  this.props.onUpdated(data);
                }}
                placeholder="Select alignment"
              />
            </div>
            <RangeSlider
              label={"Padding"}
              min={0}
              max={35}
              step={1}
              value={getCleanedPixelValue(data["custom_message_options_padding"]) || 0}
              onChange={(propertyName, value) => {
                data["custom_message_options_padding"] = `${value}px`;
                this.props.onUpdated(data);
              }}
              propertyName="padding"
              labelClassName="storefront-popup-settings-sub-heading"
            />
          </Collapsible>
        </Border>
      </>
    );
  }

  _breadCrumbsSettings() {
    let { data } = this.state;
    const openSection = this.props.openProductSettingsSection === productSettingsIds.breadCrumbsOptions;

    const breadCrumbColorPickerConfig = [
      { title: "Border color", key: "breadCrumbs_border_color" },
      { title: "Background color", key: "breadCrumbs_background_color" },
      { title: "Link color", key: "breadCrumbs_link_color" },
      { title: "Carrot color", key: "breadCrumbs_carrot_color" },
      { title: "Text color", key: "breadCrumbs_text_color" },
    ];

    return (
      <>
        <Border>
          <Collapsible trigger="Breadcrumbs" open={openSection}>
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Border Style</span>
              <Dropdown
                options={OPTIONS_BORDER_RADIUS}
                value={OPTIONS_BORDER_RADIUS.find(
                  (opt) => opt.value === data["breadCrumbs_border_style"]
                )}
                onChange={(option) => {
                  data["breadCrumbs_border_style"] = option.value;
                  this.props.onUpdated(data);
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            {renderColorPickers({
              config: breadCrumbColorPickerConfig,
              data,
              onUpdated: this.props.onUpdated,
            })}
            <div className="mb-3">
              <span className="d-block mb-2">Width</span>
              <Dropdown
                options={PRODUCT_WIDTH}
                value={PRODUCT_WIDTH.find(
                  (opt) => opt.value === data["breadCrumbs_width"]
                )}
                onChange={option => {
                  data["breadCrumbs_width"] = option.value
                  this.props.onUpdated(data)
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <RangeSlider
              label={"Padding"}
              min={0}
              max={35}
              step={1}
              value={getCleanedPixelValue(data["breadCrumbs_padding"]) || 0}
              onChange={(propertyName, value) => {
                data["breadCrumbs_padding"] = `${value}px`;
                this.props.onUpdated(data);
              }}
              propertyName="padding"
              labelClassName="storefront-popup-settings-sub-heading"
            />
          </Collapsible>
        </Border>
      </>
    );
  }

  _quantityButtonsSettings() {
    let { data } = this.state;
    const openSection = this.props.openProductSettingsSection === productSettingsIds.quantityAndButtonsOptions;

    return (
      <>
        <Border>
          <Collapsible trigger="Quantity and Buttons" open={openSection}>
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Border Style</span>
              <Dropdown
                options={OPTIONS_BORDER_RADIUS}
                value={OPTIONS_BORDER_RADIUS.find(
                  (opt) => opt.value === data["quantity_buttons_border_style"]
                )}
                onChange={(option) => {
                  data["quantity_buttons_border_style"] = option.value;
                  this.props.onUpdated(data);
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <ColorPicker
              title="Border color"
              color={data.quantity_buttons_border_color}
              onColorSelected={(color) => {
                data["quantity_buttons_border_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <ColorPicker
              title="Background color"
              color={data.quantity_buttons_background_color}
              onColorSelected={(color) => {
                data["quantity_buttons_background_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <ColorPicker
              title="Add to Cart Button color"
              color={data.quantity_button_addToCart_btn_color}
              onColorSelected={(color) => {
                data["quantity_button_addToCart_btn_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <ColorPicker
              title="Add to Cart Text color"
              color={data.quantity_button_addToCart_text_color}
              onColorSelected={(color) => {
                data["quantity_button_addToCart_text_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <ColorPicker
              title="Buy Now Button color"
              color={data.quantity_button_buyNow_btn_color}
              onColorSelected={(color) => {
                data["quantity_button_buyNow_btn_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <ColorPicker
              title="Buy Now Text color"
              color={data.quantity_button_buyNow_text_color}
              onColorSelected={(color) => {
                data["quantity_button_buyNow_text_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <RangeSlider
              label={"Padding"}
              min={0}
              max={35}
              step={1}
              value={getCleanedPixelValue(data["quantity_buttons_padding"]) || 0}
              onChange={(propertyName, value) => {
                data["quantity_buttons_padding"] = `${value}px`;
                this.props.onUpdated(data);
              }}
              propertyName="padding"
              labelClassName="storefront-popup-settings-sub-heading"
            />
          </Collapsible>
        </Border>
      </>
    );
  }


  _renderVariantTilePriceDisplaySettings(){
    let { data } = this.state
    return (
      <>
        <br/>
        <Toggle
          id="toggle_variant_tile_price"
          checked={data.display_variant_tile_price}
          title="Display Prices On Variant"
          tooltip='Display prices on the last variant option when the variant type is set to "Button Vertical" and "Button Horizontal".'
          onChange={checked => {
            data.display_variant_tile_price = checked
            this.props.onUpdated(data)
          }}
        />
      </>
    )
  }

  _renderColorType(){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "dropdown",
        label: "Dropdown Menu"
      },
      {
        value: "square",
        label: "Square Swatches"
      },
      {
        value: "circular",
        label: "Circular Swatches"
      },
      {
        value: "square_titles",
        label: "Square Swatches With Titles"
      },
      {
        value: "circular_titles",
        label: "Circular Swatches With Titles"
      },
      {
        value: "tiles",
        label: "Tiles"
      },
    ]
    return (
      <>
        <span>Color Swatch Style</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == data.color_picker_style
          )}
          onChange={option => {
            data.color_picker_style = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
      </>
    )
  }

  _renderVariantType(value, imgTileVariantType){
    let { data } = this.state

    let key = `variant${value}_style`

    let OPTIONS = [
      {
        value: "dropdown",
        label: "Dropdown Menu"
      },
      {
        value: "btn_horizontal",
        label: "Button Horizontal"
      },
      {
        value: "btn_vertical",
        label: "Button Vertical"
      }
    ]

    const imageTileVariantOptionSelected = imgTileVariantType === key

    if (imageTileVariantOptionSelected || !imgTileVariantType) {
      OPTIONS.push({
        value: "img_tile",
        label: "Image Tile"
      })
    }
    return (
      <>
        <br/>
        <span>Variant {value} Style</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == data[key]
          )}
          onChange={option => {
            data[key] = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
        {imageTileVariantOptionSelected && this._renderImageTileVariantOptions(value)}
      </>
    )
  }

  _renderImageTileVariantOptions(value){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "left",
        label: "Left"
      },
      {
        value: "right",
        label: "Right"
      },
      {
        value: "top",
        label: "Top"
      },
      {
        value: "img-only",
        label: "Image Only"
      }
    ]
    return (
      <>
        <span>Variant {value} Image Position</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == (data.img_tile_position || "right")
          )}
          onChange={option => {
            data.img_tile_position = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
        {data.img_tile_position === "img-only" && this._renderImageOnlyTileAspectRatioOptions(value)}
      </>
    )
  }

  _renderImageOnlyTileAspectRatioOptions(value){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "",
        label: "Default"
      },
      {
        value: "img-tile-ratio img-tile-ratio-1x1",
        label: "1x1"
      },
      {
        value: "img-tile-ratio img-tile-ratio-4x3",
        label: "4x3"
      },
      {
        value: "img-tile-ratio img-tile-ratio-16x9",
        label: "16x9"
      },
      {
        value: "img-tile-ratio img-tile-ratio-21x9",
        label: "21x9"
      }
    ]
    return (
      <>
        <span>Variant {value} Aspect Ratio</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == (data.img_only_aspect_ratio || "default")
          )}
          onChange={option => {
            data.img_only_aspect_ratio = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
      </>
    )
  }

  _renderAccordionIconPicker(iconValue, iconKey) {
    const { data } = this.state;
    return <>
      <IconAndSVGPicker
        label="Current Icon"
        displayIconFontSize={30}
        displayIconClassName=""
        currentIcon={iconValue}
        iconPickerColumnWidth={110}
        iconPickerClassName=""
        iconPickerWidth={335}
        iconPickerRowHeight={110}
        onSelected={(actionType, actionValue) => {
          if (actionType === "svg") {
            data[iconKey] = updateIconValue(actionType, iconValue, actionValue)
            this.props.onUpdated(data)
          } else if (actionType === 'type') {
            data[iconKey] = updateIconType(iconValue, actionValue)
            this.props.onUpdated(data)
          } else {
            let tempIcon = ""
            if (actionValue.icon.startsWith("fa-")) {
              tempIcon = actionValue.icon
            } else {
              tempIcon = `icon icon--lg icon-${actionValue.name}`
            }
            data[iconKey] = updateIconValue(actionType, iconValue, tempIcon)
            this.props.onUpdated(data)
          }
        }}
      />
    </>
  }

  _renderAccordionIcons(iconTitle, iconKey) {
    const { data } = this.state
    return <>
      <span>{iconTitle}</span>
      <Collapsible trigger={iconTitle} className="mb-3">
        <br />
        {this._renderAccordionIconPicker(data[iconKey], iconKey)}
      </Collapsible>
    </>
  }

  _renderMetaFieldsSettings() {
    const { data } = this.state
    const OPTIONS = [
      {
        value: "tabs",
        label: "Tabs"
      },
      {
        value: "collapsible-list",
        label: "Collapsible List"
      }
    ]
    const openSection = this.props.openProductSettingsSection === productSettingsIds.metaFields
    return (
      <>
        {this._renderRefElement(openSection)}
        <Border>
          <Collapsible
            trigger="Metafields"
            open={openSection}
          >
            <br/>
            <span>Type</span>
            <Dropdown
              options={OPTIONS}
              value={OPTIONS.find(
                (mode) => mode.value === data.meta_field_type
              )}
              onChange={option => {
                data.meta_field_type = option.value
                this.props.onUpdated(data)
              }}
              placeholder="Select An Option"
            />
            {data.meta_field_type !== "collapsible-list" && 
              <>
                <div className="mb-3">
                  <span className="d-block mb-2">Border Style</span>
                  <Dropdown
                    options={OPTIONS_BORDER_RADIUS}
                    value={OPTIONS_BORDER_RADIUS.find(
                      (opt) => opt.value === (data["meta_field_border_style"] ?? "6px")
                    )}
                    onChange={(option) => {
                      data["meta_field_border_style"] = option.value;
                      this.props.onUpdated(data);
                    }}
                    placeholder="Select An Option"
                  />
                </div>
                <br/>
                <ColorPicker
                  title="Selected Tab Color"
                  color={data.meta_field_selected_tab_color}
                  onColorSelected={(color) => {
                    data["meta_field_selected_tab_color"] = color;
                    this.props.onUpdated(data);
                  }}
                />
              </>
            }
            {data.meta_field_type === "collapsible-list" && <>
              { this._renderAccordionIcons("Open Icon", "collapsible_list_open_icon") }
              { this._renderAccordionIcons("Close Icon", "collapsible_list_close_icon") }
              <Toggle
                id="toggle_collapsible_list"
                checked={data.collapsible_list_toggle}
                title="Toggle List"
                onChange={checked => {
                  data.collapsible_list_toggle = checked
                  this.props.onUpdated(data)
                }}
              />
              <div className="mb-3">
                <span className="d-block mb-2">Border Style</span>
                <Dropdown
                  options={COLLAPSIBLE_BORDER_RADIUS}
                  value={COLLAPSIBLE_BORDER_RADIUS.find(
                    (opt) => opt.value === data["collapsible_list_border_style"]
                  )}
                  onChange={(option) => {
                    data["collapsible_list_border_style"] = option.value;
                    this.props.onUpdated(data);
                  }}
                  placeholder="Select An Option"
                />
              </div>
              <br/>
              {data.collapsible_list_border_style !== "none" && <ColorPicker
                title="Line color"
                color={data.collapsible_list_line_color}
                onColorSelected={(color) => {
                  data["collapsible_list_line_color"] = color;
                  this.props.onUpdated(data);
                }}
              />}
              <ColorPicker
                title="Icon color"
                color={data.collapsible_list_icon_color}
                onColorSelected={(color) => {
                  data["collapsible_list_icon_color"] = color;
                  this.props.onUpdated(data);
                }}
              />
            </>}
            <br/>
            <ColorPicker
              title="Border color"
              color={data.meta_field_border_color}
              onColorSelected={(color) => {
                data["meta_field_border_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <br/>
            <b><span>Header</span></b>
            <ColorPicker
              title="Text color"
              color={data.meta_field_text_color}
              onColorSelected={(color) => {
                data["meta_field_text_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <ColorPicker
              title="Background color"
              color={data.meta_field_bg_color}
              onColorSelected={(color) => {
                data["meta_field_bg_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <b><span>Body</span></b>
            <ColorPicker
              title="Body Text color"
              color={data.meta_field_body_text_color}
              onColorSelected={(color) => {
                data["meta_field_body_text_color"] = color;
                this.props.onUpdated(data);
              }}
            />
            <ColorPicker
              title="Body Background color"
              color={data.meta_field_body_bg_color}
              onColorSelected={(color) => {
                data["meta_field_body_bg_color"] = color;
                this.props.onUpdated(data);
              }}
            />
          </Collapsible>
        </Border>
      </>
    )
  }

  _renderSingleIconPicker = (iconValue, iconKey, label = "Icon") => {
    const { data } = this.state;
    return (
      <>
        <span className="d-block mb-2">{label}</span>
        <IconAndSVGPicker
          label="Current Icon"
          displayIconFontSize={30}
          displayIconClassName=""
          currentIcon={iconValue}
          iconPickerColumnWidth={110}
          iconPickerClassName=""   // keep default styling
          iconPickerWidth={335}
          iconPickerRowHeight={110}
          onSelected={(actionType, actionValue) => {
            if (actionType === "svg") {
              data[iconKey] = updateIconValue(actionType, iconValue, actionValue);
            } else if (actionType === "type") {
              data[iconKey] = updateIconType(iconValue, actionValue);
            } else {
              let tempIcon = actionValue.icon?.startsWith("fa-")
                ? actionValue.icon
                : `icon icon--lg icon-${actionValue.name}`;
              data[iconKey] = updateIconValue(actionType, iconValue, tempIcon);
            }
            this.props.onUpdated(data);
          }}
        />
      </>
    );
  };


  _shareProductSettings() {
    const { data } = this.state;
    const openSection = this.props.openProductSettingsSection === productSettingsIds.shareProduct;

    return (
      <>
        {this._renderRefElement(openSection)}
        <Border>
          <Collapsible trigger="Share Product" open={openSection}>
            <br/>

            <div className="mb-4">
              {this._renderSingleIconPicker(data.share_icon, "share_icon", "Share Icon")}
            </div>

            <div className="mb-3">
              <span className="d-block mb-2">Border Style</span>
              <Dropdown
                options={OPTIONS_BORDER_RADIUS}
                value={OPTIONS_BORDER_RADIUS.find(
                  (opt) => opt.value === (data.share_border_style ?? "0px")
                )}
                onChange={(option) => {
                  data.share_border_style = option.value;
                  this.props.onUpdated(data);
                }}
                placeholder="Select An Option"
              />
            </div>

            <div className="mb-4">
              <ColorPicker
                title="Border color"
                color={data.share_border_color}
                onColorSelected={(color) => {
                  data.share_border_color = color;
                  this.props.onUpdated(data);
                }}
              />
            </div>

            <div className="mb-4">
              <ColorPicker
                title="Text color"
                color={data.share_text_color}
                onColorSelected={(color) => {
                  data.share_text_color = color;
                  this.props.onUpdated(data);
                }}
              />
            </div>

            <div className="mb-4">
              <ColorPicker
                title="Background color"
                color={data.share_background_color}
                onColorSelected={(color) => {
                  data.share_background_color = color;
                  this.props.onUpdated(data);
                }}
              />
            </div>

            <div className="mb-3">
              <span className="d-block mb-2">Text Alignment</span>
              <Dropdown
                options={PRODUCT_ALIGNMENT}
                value={PRODUCT_ALIGNMENT.find(
                  (opt) => opt.value === (data.share_alignment ?? "center")
                )}
                onChange={(option) => {
                  data.share_alignment = option.value;
                  this.props.onUpdated(data);
                }}
                placeholder="Select alignment"
              />
            </div>

            <div className="mb-3">
              <span className="d-block mb-2">Width</span>
              <Dropdown
                options={PRODUCT_WIDTH}
                value={PRODUCT_WIDTH.find(
                  (opt) => opt.value === (data.share_width ?? "max-content")
                )}
                onChange={(option) => {
                  data.share_width = option.value;
                  this.props.onUpdated(data);
                }}
                placeholder="Select An Option"
              />
            </div>

            <RangeSlider
              label={"Padding"}
              min={0}
              max={50}
              step={1}
              value={getCleanedPixelValue(data.share_padding) || 0}
              onChange={(_, value) => {
                data.share_padding = `${value}px`;
                this.props.onUpdated(data);
              }}
              propertyName="padding"
              labelClassName="storefront-popup-settings-sub-heading"
            />
          </Collapsible>
        </Border>
      </>
    );
  }

  _renderResetLayoutModal() {
    return (
      <PortalModal
        show={this.state.showResetLayoutModal}
        showAsSideMenu="false"
        onHide={() => this.setState({showResetLayoutModal: false})}
      >
        <div className="modal-share">
          <div className="modal-head">
            <h2 className="mb-0">Reset Layout</h2>
          </div>

          <div className="row modal-body">
            <div className="col-md-12">
              <h4>Are you sure you want to reset the layout to its default configuration?</h4>
            </div>
          </div>

          <div className="text-right modal-footer">
            <a
              className="btn type--uppercase"
              onClick={() => this.setState({showResetLayoutModal: false})}
            >
            <span className="btn__text">
              Cancel
            </span>
            </a>
            <a
              className="btn btn--primary type--uppercase"
              style={{
                background: "#fa6160",
                borderColor: "#fa6160"
              }}
              onClick={() => {
                this.setState({showResetLayoutModal: false});
                this.handleLayoutUpdate(this.defaultLayout);
              }}
            >
            <span className="btn__text">
              Reset Layout
            </span>
            </a>
          </div>
        </div>
      </PortalModal>
    );
  }

  _renderSubscribeAndSaveSettingsIconPicker(iconValue, tabKey) {
    const updatedKey = tabKey === 'oneTime' ? 'oneTimeIcon' : 'subscribeIcon'
    return <>
      <IconAndSVGPicker
        label="Current Icon"
        displayIconFontSize={30}
        displayIconClassName=""
        currentIcon={iconValue}
        iconPickerColumnWidth={110}
        iconPickerClassName="subscribe-icon-grp"
        iconPickerWidth={356}
        iconPickerRowHeight={110}
        onSelected={(actionType, actionValue) => {
          if (actionType === "svg") {
            this.props.updateSubscribeAndSaveSettings({
              [updatedKey]: updateIconValue(actionType, iconValue, actionValue)
            });
          } else if (actionType === 'type') {
            this.props.updateSubscribeAndSaveSettings({
              [updatedKey]: updateIconType(iconValue, actionValue)
            });
          } else {
            let iconClass = actionValue.icon.startsWith('fa-') ? actionValue.icon : `icon icon--lg icon-${actionValue.name}`;
            iconClass = updateIconValue(actionType, iconValue, iconClass)
            this.props.updateSubscribeAndSaveSettings({
              [updatedKey]: iconClass
            });
          }
        }}
      />
    </>
  }

  _renderSubscribeAndSaveSettings() {
    const { subscribeAndSaveSettings, updateSubscribeAndSaveSettings } = this.props;
    const openSection = this.props.openProductSettingsSection === productSettingsIds.subAndSave
    return (
      <>
        {this._renderRefElement(openSection)}
        <Border>
          <Collapsible
            trigger="Subscribe & Save"
            open={openSection}
          >
            <br/>
            <div className="mb-3">
              <span className="d-block mb-2">Layout</span>
              <Dropdown
                options={OPTIONS_Layout}
                value={OPTIONS_Layout.find(
                  (opt) => opt.value === subscribeAndSaveSettings.layoutStyle
                )}
                onChange={(option) => {
                  updateSubscribeAndSaveSettings({
                    layoutStyle: option.value,
                  });
                }}
                placeholder="Select An Option"
              />
            </div>
            <br/>
            <ColorPicker
              title="Text color"
              color={subscribeAndSaveSettings.textColor}
              onColorSelected={(color) => updateSubscribeAndSaveSettings('textColor', color)}
            />
            <div className="mb-4">
              <ColorPicker
                title="Selected Text Color"
                color={subscribeAndSaveSettings.selectedTextColor}
                onColorSelected={(color) => updateSubscribeAndSaveSettings('selectedTextColor', color)}
              />
            </div>
            <div className="mb-4">
              <ColorPicker
                title="Background color"
                color={subscribeAndSaveSettings.backgroundColor}
                onColorSelected={(color) => updateSubscribeAndSaveSettings('backgroundColor', color)}
              />
            </div>
            <div className="mb-4">
              <ColorPicker
                title="Selected background color"
                color={subscribeAndSaveSettings.selectedBackgroundColor}
                onColorSelected={(color) => updateSubscribeAndSaveSettings('selectedBackgroundColor', color)}
              />
            </div>
            <div className="mb-4">
              <ColorPicker
                title="Border color"
                color={subscribeAndSaveSettings.borderColor}
                onColorSelected={(color) => updateSubscribeAndSaveSettings('borderColor', color)}
              />
            </div>
            <div className="mb-4">
              <ColorPicker
                title="Selected border color"
                color={subscribeAndSaveSettings.selectedBorderColor}
                onColorSelected={(color) => updateSubscribeAndSaveSettings('selectedBorderColor', color)}
              />
            </div>
            <div className="mb-3">
              <span className="d-block mb-2">Border Style</span>
              <Dropdown
                options={OPTIONS_BORDER_RADIUS}
                value={OPTIONS_BORDER_RADIUS.find(
                  (opt) => opt.value === subscribeAndSaveSettings.borderStyle
                )}
                onChange={(option) => {
                  updateSubscribeAndSaveSettings({
                    borderStyle: option.value,
                  });
                }}
                placeholder="Select An Option"
              />
            </div>
            <div className="mb-3">
              <span className="d-block mb-2">Display options for savings</span>
              <Dropdown
                options={OPTIONS_DISCOUNT}
                value={OPTIONS_DISCOUNT.find(
                  (opt) => opt.value === subscribeAndSaveSettings.discountFormat
                )}
                onChange={(option) => {
                  updateSubscribeAndSaveSettings('discountFormat', option.value);
                }}
                placeholder="Select Discount Format"
              />
            </div>

            <div className="icon-toggle-section mt-5">
              <Toggle
                id="customIconToggle"
                title="Choose Custom Icon"
                checked={subscribeAndSaveSettings.useCustomIcon}
                onChange={(checked) => {
                  if (!checked) {
                    updateSubscribeAndSaveSettings({
                      oneTimeIcon: '',
                      subscribeIcon: '',
                      useCustomIcon: false
                    });
                  } else {
                    updateSubscribeAndSaveSettings('useCustomIcon', true);
                  }
                }}
              />

              {subscribeAndSaveSettings.useCustomIcon && (
                <div className="tabs-container tabs--folder">
                  <ul className="tabs subscribe-icon">
                    {[
                      { key: 'oneTime', label: 'One Time' },
                      { key: 'subscribe', label: 'Subscribe & Save' },
                    ].map(tab => (
                      <li
                        key={tab.key}
                        className={subscribeAndSaveSettings.activeIconTab === tab.key ? 'active' : ''}
                        onClick={() => updateSubscribeAndSaveSettings('activeIconTab', tab.key)}
                      >
                        <div className="tab__title">
                          <span>{tab.label}</span>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <ul className="tabs-content">
                    {['oneTime', 'subscribe'].map(tabKey => (
                      <li
                        key={tabKey}
                        className={subscribeAndSaveSettings.activeIconTab === tabKey ? 'active' : ''}
                      >
                        <div className="tab__content">
                          {this._renderSubscribeAndSaveSettingsIconPicker(subscribeAndSaveSettings[`${tabKey}Icon`], tabKey)}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </Collapsible>
        </Border>
      </>
    )
  }

  _renderProductDescriptionSettings() {
    const { data } = this.state
    const shapeValue = data.product_description_shape || OPTIONS_PRODUCT_DESCRIPTION_SHAPE[0].value
    const openSection = this.props.openProductSettingsSection === productSettingsIds.productDescription
    return (
      <>
        {this._renderRefElement(openSection)}
        <Border>
          <Collapsible
            trigger="Description"
            open={openSection}
          >
            <br/>
            <b><span>General</span></b>
            <div className="mb-4">
              <span>Shape</span>
              <Dropdown
                options={OPTIONS_PRODUCT_DESCRIPTION_SHAPE}
                value={OPTIONS_PRODUCT_DESCRIPTION_SHAPE.find(
                  (mode) => mode.value === shapeValue
                )}
                onChange={option => {
                  data.product_description_shape = option.value
                  this.props.onUpdated(data)
                }}
                placeholder="Select An Option"
              />
            </div>
            <div className="mb-4">
              <ColorPicker
                title="Border color"
                color={data.product_description_border_color}
                onColorSelected={(color) => {
                  data.product_description_border_color = color
                  this.props.onUpdated(data)
                }}
              />
            </div>
            <div className="mb-4">
              <ColorPicker
                title="Background color"
                color={data.product_description_background_color}
                onColorSelected={(color) => {
                  data.product_description_background_color = color
                  this.props.onUpdated(data)
                }}
              />
            </div>
            <b><span>Header</span></b>
            <div className='mb-4'>
              <span>Title</span>
              <input
                type="text"
                className="mb--05"
                defaultValue={data.product_description_header_text || "Product Description"}
                onChange={(event) => {
                  data.product_description_header_text = event.target.value || ""
                  this.props.onUpdated(data)
                }}
              />
            </div>
            <div className='mb-4'>
              <ColorPicker
                title="Text color"
                color={data.product_description_header_text_color}
                onColorSelected={(color) => {
                  data.product_description_header_text_color = color
                  this.props.onUpdated(data)
                }}
              />
            </div>
            <b><span>Body</span></b>
            <div className='mb-4'>
              <ColorPicker
                title="Text color"
                color={data.product_description_body_text_color}
                onColorSelected={(color) => {
                  data.product_description_body_text_color = color
                  this.props.onUpdated(data)
                }}
              />
            </div>
          </Collapsible>
        </Border>
      </>
    )
  }

  render(){
    let {
      data
    } = this.state

    let imgTileVariantType = ""

    const variantTypeIndexes = [1, 2, 3]

    variantTypeIndexes.forEach((item) => {
      const key = `variant${item}_style`
      if (data[key] === "img_tile") {
        imgTileVariantType = key
      }
    })

    return (
      <>
        {this._renderLayoutPreviewUI()}

        {this._displaySettings()}

        {this._breadCrumbsSettings()}

        {this._renderProductImageSettings()}

        {this._productPriceSettings()}

        {this._productTitleSettings()}

        {this._renderVariantSettings()}

        {this._customMessageSettings()}

        {this._quantityButtonsSettings()}

        {this._shareProductSettings()}

        {this._renderMetaFieldsSettings()}

        {this._renderResetLayoutModal()}

        {this._renderSubscribeAndSaveSettings()}

        {this._renderProductDescriptionSettings()}

        {this._renderDetailSettings()}

        {this._renderRefElement(this.props.openProductSettingsSection === productSettingsIds.htmlBlock)}
      </>
    )
  }
}
